export const getData = state => state.reportTrailerFuelings.getIn(['list', 'data'])
export const getFetching = state => state.reportTrailerFuelings.getIn(['list', 'fetching'])
export const getError = state => state.reportTrailerFuelings.getIn(['list', 'error'])

export const getDetailsData = state => state.reportTrailerFuelings.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportTrailerFuelings.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportTrailerFuelings.getIn(['details', 'error'])
